import React, { useEffect, useRef } from "react";
import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";

/** Common Components */
import Buttons from "../../../../components/ui/button/Buttons";
import FormCreator from "../../../../components/finalForms/FormCreator";

/** Common Services & Data Files */
import ToastService from "../../../../services/toastService/ToastService";

/** Configuration Files */
import PasswordForm from "./Password.data";

/** RTK Query */
import { useAddResetPassMutation } from "../../../../app/services/ResetPasswordAPI";


const AddUserPassword = (props) => {

  const userId = props.userData;

  const navigate = useNavigate();

  const resetpassref = useRef();

  const [addResetPass, {
    isLoading: isDataLoading,
    isSuccess: isDataSucess
  }] = useAddResetPassMutation();

  const backtoList = () => {
    navigate("/admin/users");
  };

  const handalResetData = () => {
    const UserData = resetpassref.current.getFormData();

    if (UserData && UserData.password === UserData.Confirmpassword) {
      let request = {
        ...UserData,
        userId: userId,
      };
      addResetPass(request);
    }
    else if (UserData && UserData.password !== UserData.Confirmpassword) {
      ToastService.error("Password does not match")
    }
  };

  useEffect(() => {
    if (isDataSucess) {
      ToastService.success("Password reset");
      backtoList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDataSucess]);

  return (
    <>
      <form>
        <div className="row">
          <FormCreator
            config={PasswordForm}
            ref={resetpassref}
          />
        </div>
      </form>
      <div className="d-flex justify-content-end">
        <Buttons
          buttonTypeClassName="dark-btn"
          buttonText="Cancel"
          onClick={backtoList}
        />
        <Buttons
          buttonTypeClassName="theme-btn ml-4"
          buttonText="Update"
          onClick={handalResetData}
          isLoading={isDataLoading}
        />
      </div>
    </>
  );
};

AddUserPassword.propTypes = {
  userData: PropTypes.number
};
export default AddUserPassword;
